import React, { PureComponent } from 'react'

import Button from 'app/components/ButtonDefault'
import { ModalContent, ModalTitle, ModalBody, ModalFooter } from 'app/components/Modal'

class LoginEmailTokenSentSuccessModal extends PureComponent {
  componentDidMount() {
    this.props.clearAuthStatuses()
  }

  render() {
    const { title, onRequestClose, body } = this.props
    return (
      <ModalBody onRequestClose={() => onRequestClose()}>
        <ModalTitle>{title}</ModalTitle>
        <ModalContent>{body}</ModalContent>
        <ModalFooter>
          <Button sm primary onClick={() => onRequestClose()}>
            OK
          </Button>
        </ModalFooter>
      </ModalBody>
    )
  }
}

export default LoginEmailTokenSentSuccessModal
